import { Theme } from '@mui/material/styles'

export default function Badge(_: Theme) {
  return {
    MuiBadge: {},
  }
}
